import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import {Modal} from '../inspinia'
import ModalSendTestSucesso from './modalSendTestSucesso'

class ModalSendTest extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = 
        {
            loading: false,

            form: 
            {
                email: ""
            },
            modalSucessoIsOpen: false, 

            idCampanha: this.props.campanha.idCampanha,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSend   = this.handleSend.bind(this);
        this.handleSucessoToggle = this.handleSucessoToggle.bind(this);
    }

    handleChange(e)
    {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }
    
    handleSend(e)
    {
        e.preventDefault(); if (this.state.loading) return;

        let self = this;

        const url = `${ c.API_BASE_URL }/sendEmailTest`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                email: this.state.form.email,
                idCampanha: this.state.idCampanha,
              })
        };

        callApi(url, options, function(response)
        { 
            self.handleSucessoToggle();
        });
    }

    handleSucessoToggle(e)
    {
        this.setState({ ...this.state, modalSucessoIsOpen: !this.state.modalSucessoIsOpen });
    }

    render()
    {
        const form = this.state.form;

        return (         
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} style={{maxWidth: "592px"}}>
                    
                    <h3 className="fs-20 fw-600 text-body mb-5">Envio de e-mail de teste
                    </h3>

                    <div className="input-group d-inline-flex mb-3" style={{width: "360px"}}>
                        <input type="text" name="email" value={form.email} onChange={this.handleChange} placeholder="E-mail" className="form-control"/>
                    </div>

                    <div className="input-group d-inline-flex container text-left mb-4" style={{width: "360px"}}>
                        <div className="row">
                            <div className="col-1 m-0 p-0"><img src="assets/images/info.svg" className="text-info"/></div>
                            
                            <div className="col-11 m-0 p-0 fs-12 pr-0">
                                Será enviado um e-mail com os dados do primeiro registro da listagem de contatos para o e-mail informado.
                            </div>
                        </div>
                    </div>

                    <div className="input-group d-block mt-0">
                        <button type="button" onClick={this.handleSend} className="btn btn-primary mx-1" style={{width: "130px"}}>Enviar</button>
                    </div>
                </Modal>

                <ModalSendTestSucesso isOpen={this.state.modalSucessoIsOpen} toggle={this.handleSucessoToggle} />
            </div>  
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalSendTest));
